import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.scss';
import { Provider } from 'react-redux';
import store from './store/index';
import { setAppConfigs } from "./utils/config";
import constants  from "./utils/config/const.json";
import { getPantoneColor } from './utils/getPantoneColor';

declare const window: any;
const appConfig: any = window.appConfig;
const additonalConfigs = {
  baseURL: window.baseURL,
  locale_details: window.locale_details,
  locale: `${appConfig.language}-${appConfig.regionCode}`,
  currencyLocale: `${appConfig.language}_${appConfig.regionCode}`,
  isNASite: ['US', 'CA'].includes(appConfig.regionCode),
  isFbConversionEnabled: appConfig.isFbConversionEnabled,
};
const loadConfigs = async () => {
  setAppConfigs({ ...appConfig, ...additonalConfigs, ...window.Config, ...constants });
  try {
    const pantoneColors : any = await getPantoneColor();
    pantoneColors && setAppConfigs({ ...appConfig, ...additonalConfigs, ...window.Config, ...constants, pantoneColors });
  } catch (error) {
    console.log(error, "Error in pantone color")
  } finally {
    ReactDOM.render(
      <Provider store={store}>
        <React.StrictMode>
          <App ROUTE_LOCALE={appConfig.regionCode} />
        </React.StrictMode>
      </Provider>,
      document.getElementById('cart-spa-root')
    );
  }
};

loadConfigs();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
